import React, { useEffect, useState, useRef } from "react";
import DataTable from 'react-data-table-component';
import { showSuccessToast } from "../../../utils/GlobalToast";
import { createUser, deleteUser, fetchAllUser, importUser, updateUser } from "../../../resources/UserResource";
import { fetchAllPrivilege } from "../../../resources/PrivilegeResource";
import { fetchAllDepartement } from "../../../resources/DepartementResource";
import { baseUrl } from "../../../constants/Constant";
import { format } from "date-fns";
import { getLocalAuth } from "../../../utils/AuthUtils";
import ErrorNotFound from "../../errors/Error";
import FormatDownload from "../../../components/format-download";

function User() {
  const values = getLocalAuth()
  const privilege = JSON.parse(values.authPrivilege);

  let dataPrivilegeDetail = privilege.data.menu.filter(data => {
    return data.code === "User"
  });

  let dataRead = dataPrivilegeDetail.length === 0 ? [] : dataPrivilegeDetail[0].action_page.filter(data => {
    return data.code === "Read"
  });

  let dataCreate = dataPrivilegeDetail.length === 0 ? [] : dataPrivilegeDetail[0].action_page.filter(data => {
    return data.code === "Create"
  });

  let dataUpdate = dataPrivilegeDetail.length === 0 ? [] : dataPrivilegeDetail[0].action_page.filter(data => {
    return data.code === "Update"
  });

  let dataDelete = dataPrivilegeDetail.length === 0 ? [] : dataPrivilegeDetail[0].action_page.filter(data => {
    return data.code === "Delete"
  });

  let dataImport = dataPrivilegeDetail.length === 0 ? [] : dataPrivilegeDetail[0].action_page.filter(data => {
    return data.code === "Import"
  });

  const [dataUser, setDataUser] = useState([]);
  const [dataPrivilege, setDataPrivilege] = useState([]);
  const [dataDepartement, setDataDepartement] = useState([]);
  const [name, setName] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [privilegeId, setPrivilegeId] = useState("default");
  const [departementId, setDepartementId] = useState("default");

  const [selectedFile, setSelectedFile] = useState(null);
  const ref = useRef(null);
  const refEdit = useRef(null);

  const [idEdit, setIdEdit] = useState(null);
  const [nameEdit, setNameEdit] = useState("");
  const [usernameEdit, setUsernameEdit] = useState("");
  const [passwordEdit, setPasswordEdit] = useState("");
  const [emailEdit, setEmailEdit] = useState("");
  const [privilegeIdEdit, setPrivilegeIdEdit] = useState("default");
  const [departementIdEdit, setDepartementIdEdit] = useState("default");

  const [isError, setIsError] = useState(false);
  const [error, setError] = useState("");
  const [isErrorEdit, setIsErrorEdit] = useState(false);
  const [errorEdit, setErrorEdit] = useState("");
  const [isErrorImport, setIsErrorImport] = useState(false);
  const [errorImport, setErrorImport] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);

  const [selectedImage, setSelectedImage] = useState(null);
  const [defaultImage, setDefaultImage] = useState(null);

  const fetchUser = () => {
    fetchAllUser()
      .then((res) => {
        setDataUser(res.data);
      })
      .catch((err) => {
        setDataUser([]);
      });
  };

  const fetchPrivilege = () => {
    fetchAllPrivilege()
      .then((res) => {
        setDataPrivilege(res.data);
      })
      .catch((err) => {
        setDataPrivilege([]);
      });
  };

  const fetchDepartement = () => {
    fetchAllDepartement()
      .then((res) => {
        setDataDepartement(res.data);
      })
      .catch((err) => {
        setDataDepartement([]);
      });
  };

  useEffect(() => {
    fetchUser();
    fetchPrivilege();
    fetchDepartement();

  }, []);

  const postImportUser = (selectedFile) => {
    setIsLoading(true);
    importUser(selectedFile).then((res) => {
      setIsLoading(false);
      setIsErrorImport(false);
      showSuccessToast("Success Import User!");
      setShowImportModal(false);
      fetchUser();
    }).catch((err) => {
      setIsLoading(false);
      setErrorImport(err);
      setIsErrorImport(true);
    });
  }

  const handleImport = (e) => {
    e.preventDefault();

    postImportUser(selectedFile);
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    postUser(name, username, email, password, privilegeId, departementId, selectedImage);
  }

  const postUser = (name, username, email, password, privilegeId, departementId, selectedImage) => {
    setIsLoading(true);
    createUser(name, username, email, password, privilegeId, departementId, selectedImage).then((res) => {
      setIsLoading(false);
      setIsError(false);
      showSuccessToast("Success Added User!");
      setShowAddModal(false);
      setName("");
      setUsername("");
      setPassword("");
      setEmail("");
      setPrivilegeId("default");
      setDepartementId("default");
      setSelectedImage(null);
      if (ref.current) {
        ref.current.value = "";
        ref.current.type = "text";
        ref.current.type = "file";
      }
      fetchUser();
    }).catch((err) => {
      setIsLoading(false);
      setError(typeof err === 'undefined' ? 'There was an error checking your connection or input' : err);
      setIsError(true);
    });
  }

  const handleData = (data) => {
    setIdEdit(data.id);
    setNameEdit(data.name);
    setUsernameEdit(data.username);
    setEmailEdit(data.email);
    setPasswordEdit(data.password);
    setDefaultImage(data.image);
    setPrivilegeIdEdit(data.privilege.name === null ? "default" : data.privilege_id);
    setDepartementIdEdit(data.department.name === null ? "default" : data.department_id);
  }

  const handleDelete = () => {
    setIsLoading(true);
    deleteUser(idEdit).then((res) => {
      setIsError(false);
      showSuccessToast("Success Deleted User!");
      setShowDeleteModal(false);
      setIsLoading(false);
      fetchUser();
    }).catch((err) => {
      setError(typeof err === 'undefined' ? 'There was an error checking your connection or input' : err);
      setIsError(true);
      setIsLoading(false);
    });
  }

  const handleEdit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    if (selectedImage === null) {
      fetch(`${baseUrl}/${defaultImage}`)
        .then((res) => res.blob())
        .then(async (myBlob) => {
          const myFile = new File([myBlob], 'image.jpeg', { type: myBlob.type });
          await updateUser(idEdit, nameEdit, usernameEdit, emailEdit, passwordEdit, privilegeIdEdit, departementIdEdit, myFile).then((res) => {
            setIsLoading(false);
            setIsErrorEdit(false);
            showSuccessToast("Success Updated User!");
            setShowEditModal(false);
            setIdEdit("");
            setNameEdit("");
            setUsernameEdit("");
            setEmailEdit("");
            setPasswordEdit("");
            setDefaultImage("");
            setPrivilegeIdEdit("");
            setDepartementIdEdit("");
            setSelectedImage(null);
            if (refEdit.current) {
              refEdit.current.value = "";
              refEdit.current.type = "text";
              refEdit.current.type = "file";
            }
            fetchUser();
          }).catch((err) => {
            setIsLoading(false);
            setErrorEdit(err);
            setIsErrorEdit(true);
          });
        }).catch((err) => {
          setIsLoading(false);
          setErrorEdit(err);
          setIsErrorEdit(true);
        });
    } else {
      updateUser(idEdit, nameEdit, usernameEdit, emailEdit, passwordEdit, privilegeIdEdit, departementIdEdit, selectedImage).then((res) => {
        setIsLoading(false);
        setIsErrorEdit(false);
        showSuccessToast("Success Updated User!");
        setShowEditModal(false);
        setSelectedImage(null);
        if (refEdit.current) {
          refEdit.current.value = "";
          refEdit.current.type = "text";
          refEdit.current.type = "file";
        }
        fetchUser();
      }).catch((err) => {
        setIsLoading(false);
        setErrorEdit(err);
        setIsErrorEdit(true);
      });
    }
  }

  const onChangeHandlerPrivilege = (e) => {
    const index = e.target.selectedIndex;
    const el = e.target.childNodes[index];
    const option = el.getAttribute("id");
    setPrivilegeId(option);
  };

  const onChangeHandlerDepartement = (e) => {
    const index = e.target.selectedIndex;
    const el = e.target.childNodes[index];
    const option = el.getAttribute("id");
    setDepartementId(option);
  };

  const onChangeHandlerPrivilegeEdit = (e) => {
    const index = e.target.selectedIndex;
    const el = e.target.childNodes[index];
    const option = el.getAttribute("id");
    setPrivilegeIdEdit(option);
  };

  const onChangeHandlerDepartementEdit = (e) => {
    const index = e.target.selectedIndex;
    const el = e.target.childNodes[index];
    const option = el.getAttribute("id");
    setDepartementIdEdit(option);
  };

  const handleImgLoadingError = (e) => {
    // default image add, if associated image is not available...
    e.target.src = '../assets/images/default-profile.png';
  };

  const columns = [
    {
      name: 'No',
      cell: (row, index) => index + 1,
      width: '60px'
    },
    {
      name: 'Image',
      selector: row => (<div className="product-img bg-transparent border">
        <img src={`${baseUrl}/${row.image}`} width="35" height="35" alt="" onError={handleImgLoadingError} />
      </div>),
      sortable: true,
    },
    {
      name: 'Name',
      selector: row => row.name,
      sortable: true,
    },
    {
      name: 'Username',
      selector: row => row.username,
      sortable: true,
    },
    {
      name: 'Email',
      selector: row => row.email,
      sortable: true,
    },
    {
      name: 'Privilege',
      selector: row => row.privilege.name === null ? '-' : row.privilege.name,
      sortable: true,
    },
    {
      name: 'Departement',
      selector: row => row.department.name === null ? '-' : row.department.name,
      sortable: true,
    },
    {
      name: 'Created At',
      selector: row => row.created_at === null ? '-' : format(row.created_at, "yyyy-MM-dd HH:mm").toString(),
      sortable: true,
      width: '180px'
    },
    {
      name: 'Updated At',
      selector: row => row.updated_at === null ? '-' : format(row.updated_at, "yyyy-MM-dd HH:mm").toString(),
      sortable: true,
      width: '180px'
    },
    {
      name: 'Actions',
      cell: row => (
        <>
          {dataDelete.length === 0 ? <div></div> : !dataDelete[0].is_active ? <div></div> : <button type="button" style={{ marginRight: "8px" }} className="btn btn-danger" onClick={() => {
            handleData(row);
            setShowDeleteModal(true);
          }}>Delete</button>}
          <div className={`modal fade ${showDeleteModal ? 'show' : ''}`} style={{ display: showDeleteModal ? 'block' : 'none', backgroundColor: 'rgba(0, 0, 0, 0.1)' }}>
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Delete this data?</h5>
                  <button type="button" className="btn-close" onClick={() => setShowDeleteModal(false)} aria-label="Close"></button>
                </div>
                {isError ? <div style={{ paddingLeft: '16px', paddingRight: '16px', paddingTop: '16px', paddingBottom: '0px' }}>
                  <div className="alert alert-danger alert-dismissible fade show" role="alert">{error}
                    <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={() => setIsError(false)}></button>
                  </div>
                </div> : null}
                <div className="modal-body">
                  {`You will delete ${nameEdit}`}
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => setShowDeleteModal(false)}>Cancel</button>
                  {!isLoading ? <button type="submit" className="btn btn-danger" onClick={() => handleDelete()}>Delete</button> :
                    <button className="btn btn-danger" type="button" disabled> <span style={{ marginRight: '4px' }} className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      Loading...</button>}
                </div>
              </div>
            </div>
          </div>
          {dataUpdate.length === 0 ? <div></div> : !dataUpdate[0].is_active ? <div></div> : <button type="button" className="btn btn-info" onClick={() => {
            handleData(row);
            setShowEditModal(true);
          }}>View</button>}
          <div className={`modal fade ${showEditModal ? 'show' : ''}`} style={{ display: showEditModal ? 'block' : 'none', backgroundColor: 'rgba(0, 0, 0, 0.1)' }}>
            <div className="modal-dialog modal-dialog-scrollable">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Master Data User</h5>
                  <button type="button" className="btn-close" onClick={() => setShowEditModal(false)} aria-label="Close"></button>
                </div>
                {isErrorEdit ? <div style={{ paddingLeft: '16px', paddingRight: '16px', paddingTop: '16px', paddingBottom: '0px' }}>
                  <div className="alert alert-danger alert-dismissible fade show" role="alert">{errorEdit}
                    <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={() => setIsErrorEdit(false)}></button>
                  </div>
                </div> : null}
                <div className="modal-body">
                  <form onSubmit={handleEdit}>
                    <div className="mb-3">
                      <label className="form-label fw-bold">Name</label>
                      <input required type="text" value={nameEdit} onChange={(e) => setNameEdit(e.target.value)} className="form-control" />
                    </div>
                    <div className="mb-3">
                      <label className="form-label fw-bold">Username</label>
                      <input disabled required type="text" value={usernameEdit} onChange={(e) => setUsernameEdit(e.target.value)} className="form-control" />
                    </div>
                    <div className="mb-3">
                      <label className="form-label fw-bold">Email</label>
                      <input required type="text" value={emailEdit} onChange={(e) => setEmailEdit(e.target.value)} className="form-control" />
                    </div>
                    <div className="mb-3">
                      <label className="form-label fw-bold">Change Password</label>
                      <input type="password" value={passwordEdit} onChange={(e) => setPasswordEdit(e.target.value)} className="form-control" />
                    </div>
                    <div className="mb-3">
                      <label className="form-label fw-bold">Privilege</label>
                      <select className="form-select mb-3" aria-label="Default select example"
                        required
                        value={privilegeIdEdit}
                        onChange={onChangeHandlerPrivilegeEdit}>
                        <option value="default" disabled>Select Privilege</option>
                        {
                          dataPrivilege.map((data) => {
                            return (<option id={data.id}
                              name={data.name}
                              key={data.id}
                              value={data.id}>{data.name}</option>);
                          })
                        }
                      </select>
                    </div>
                    <div className="mb-3">
                      <label className="form-label fw-bold">Departement</label>
                      <select className="form-select mb-3" aria-label="Default select example"
                        required
                        value={departementIdEdit}
                        onChange={onChangeHandlerDepartementEdit}>
                        <option value="default" disabled>Select Departement</option>
                        {
                          dataDepartement.map((data) => {
                            return (<option id={data.id}
                              name={data.name}
                              key={data.id}
                              value={data.id}>{data.name}</option>);
                          })
                        }
                      </select>
                    </div>
                    <div className="mb-3">
                      <label className="form-label fw-bold">Image</label>
                      <div className="row">
                        <div className="col-auto">
                          <div className="product-img bg-transparent border">
                            <img src={selectedImage === null ? `${baseUrl}/${defaultImage}` : URL.createObjectURL(selectedImage)} width="35" height="35" alt="" />
                          </div>
                        </div>
                        <div className="col">
                          <input className="form-control" type="file" id="formFile" accept="image/png, image/jpeg" onChange={(e) =>
                            setSelectedImage(e.target.files[0])
                          } ref={refEdit} />
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button type="button" className="btn btn-secondary" onClick={() => setShowEditModal(false)}>Cancel</button>
                      {!isLoading ? <button type="submit" className="btn btn-info">Save</button> :
                        <button className="btn btn-info" type="button" disabled> <span style={{ marginRight: '4px' }} className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                          Loading...</button>}
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </>
      ),
    },
  ];

  return (
    <div>
      {dataRead.length === 0 ? <ErrorNotFound /> : !dataRead[0].is_active ? <ErrorNotFound /> :
        <div className="page-content-wrapper">
          <div className="page-content">
            <div className="card">
              <div className="card-body">
                <div className="card-title">
                  <div className="row">
                    <div className="col">
                      <h4 className="mb-0">Master Data User</h4>
                    </div>
                    <div className="col">
                      <div className="text-end">
                        {dataCreate.length === 0 ? <div></div> : !dataCreate[0].is_active ? <div></div> : <button type="button" className="btn btn-info ms-auto radius-10" onClick={() => {
                          setShowAddModal(true);
                        }} style={{ marginRight: '8px' }}><i className='bx bx-plus'></i> User</button>}
                        {dataImport.length === 0 ? <div></div> : !dataImport[0].is_active ? <div></div> : <button type="button" className="btn btn-success ms-auto radius-10" onClick={() => {
                          setShowImportModal(true);
                        }}><i className='bx bx-import'></i> Import</button>}
                      </div>
                    </div>
                    <div className={`modal fade ${showImportModal ? 'show' : ''}`} style={{ display: showImportModal ? 'block' : 'none', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
                      <div className="modal-dialog modal-dialog-scrollable">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title">Import Data User</h5>
                            <button type="button" className="btn-close" onClick={() => {
                              setShowImportModal(false);
                            }} aria-label="Close"></button>
                          </div>
                          {isErrorImport ? <div style={{ paddingLeft: '16px', paddingRight: '16px', paddingTop: '16px', paddingBottom: '0px' }}>
                            <div className="alert alert-danger alert-dismissible fade show" role="alert">{errorImport}
                              <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={() => setIsErrorImport(false)}></button>
                            </div>
                          </div> : null}
                          <div className="modal-body">
                            <FormatDownload url={'/format-user.xlsx'} />
                            <form onSubmit={handleImport}>
                              <div className="mb-3">
                                <input required className="form-control" type="file" id="formFile" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" onChange={(e) =>
                                  setSelectedFile(e.target.files[0])
                                } />
                              </div>
                              <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => {
                                  setShowImportModal(false);
                                }}>Cancel</button>
                                {!isLoading ? <button type="submit" className="btn btn-info">Submit</button> :
                                  <button className="btn btn-info" type="button" disabled> <span style={{ marginRight: '4px' }} className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    Loading...</button>}
                              </div>
                            </form></div>
                        </div>
                      </div>
                    </div>
                    <div className={`modal fade ${showAddModal ? 'show' : ''}`} style={{ display: showAddModal ? 'block' : 'none', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
                      <div className="modal-dialog modal-dialog-scrollable">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title">Master Data User</h5>
                            <button type="button" className="btn-close" onClick={() => {
                              setShowAddModal(false);
                            }} aria-label="Close"></button>
                          </div>
                          {isError ? <div style={{ paddingLeft: '16px', paddingRight: '16px', paddingTop: '16px', paddingBottom: '0px' }}>
                            <div className="alert alert-danger alert-dismissible fade show" role="alert">{error}
                              <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={() => setIsError(false)}></button>
                            </div>
                          </div> : null}
                          <div className="modal-body">
                            <form onSubmit={handleSubmit}>
                              <div className="mb-3">
                                <label className="form-label fw-bold">Name</label>
                                <input required type="text" className="form-control" value={name} onChange={(e) => setName(e.target.value)} />
                              </div>
                              <div className="mb-3">
                                <label className="form-label fw-bold">Username</label>
                                <input required type="text" className="form-control" value={username} onChange={(e) => setUsername(e.target.value)} />
                              </div>
                              <div className="mb-3">
                                <label className="form-label fw-bold">Email</label>
                                <input required type="text" className="form-control" value={email} onChange={(e) => setEmail(e.target.value)} />
                              </div>
                              <div className="mb-3">
                                <label className="form-label fw-bold">Password</label>
                                <input required type="password" className="form-control" value={password} onChange={(e) => setPassword(e.target.value)} />
                              </div>
                              <div className="mb-3">
                                <label className="form-label fw-bold">Privilege</label>
                                <select className="form-select mb-3" aria-label="Default select example"
                                  required
                                  value={privilegeId}
                                  onChange={onChangeHandlerPrivilege}>
                                  <option value="default" disabled>Select Privilege</option>
                                  {
                                    dataPrivilege.map((data) => {
                                      return (<option id={data.id}
                                        name={data.name}
                                        key={data.id}
                                        value={data.id}>{data.name}</option>);
                                    })
                                  }
                                </select>
                              </div>
                              <div className="mb-3">
                                <label className="form-label fw-bold">Departement</label>
                                <select className="form-select mb-3" aria-label="Default select example"
                                  required
                                  value={departementId}
                                  onChange={onChangeHandlerDepartement}>
                                  <option value="default" disabled>Select Departement</option>
                                  {
                                    dataDepartement.map((data) => {
                                      return (<option id={data.id}
                                        name={data.name}
                                        key={data.id}
                                        value={data.id}>{data.name}</option>);
                                    })
                                  }
                                </select>
                              </div>
                              <div className="mb-3">
                                <label className="form-label fw-bold">Image</label>
                                <input required className="form-control" type="file" id="formFile" accept="image/png, image/jpeg" onChange={(e) =>
                                  setSelectedImage(e.target.files[0])
                                } ref={ref} />
                              </div>
                              <br></br>
                              <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => {
                                  setShowAddModal(false);
                                }}>Cancel</button>
                                {!isLoading ? <button type="submit" className="btn btn-info">Submit</button> :
                                  <button className="btn btn-info" type="button" disabled> <span style={{ marginRight: '4px' }} className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    Loading...</button>}
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                <div className="table-responsive">
                  <DataTable
                    columns={columns}
                    data={dataUser}
                    pagination
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  );
}

export default User